import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import axios from "axios";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Swal from "sweetalert2";
import { onSnapshot, doc, collection } from "firebase/firestore";
import { db } from "../../firebase";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";

function Users() {
  const [users, setUsers] = useState([]);

  const apiKey = process.env.REACT_APP_API_KEY;
  const [uid, setUid] = useState(null);
  const auth = getAuth();
  const [showModal, setShowModal] = useState(false);
  const [balance, setBalance] = useState(0);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState(null);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [userHistory, setUserHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDetails = (index) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  const fetchUsers = async () => {
    try {
      const response = await axios.get(
        `https://api.v1.spotyourleads.com/user`,
        {
          headers: {
            "x-api-key": apiKey,
            "x-admin-uid": uid,
          },
        }
      );
      setUsers(response.data || []);
    } catch (error) {
      console.error("Error fetching Users:", error);
    }
  };
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUid(user.uid);

        fetchUsers();
      } else {
        setUid(null);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUid(user.uid);
        fetchUsers();

        const isAdmin = localStorage.getItem("isAdmin");
        const isModerator = localStorage.getItem("isModerator");

        if (isAdmin !== "true" && isModerator !== "true") {
          window.location.href = "/";
        }
      } else {
        setUid(null);
        window.location.href = "/";
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!uid) return;

    const userDocRef = doc(db, "users", uid);
    const unsubscribe = onSnapshot(userDocRef, (snapshot) => {
      if (snapshot) {
        fetchUsers();
      }
    });

    return () => unsubscribe();
  }, [uid]);

  const handleSetModerator = async (userUid) => {
    try {
      const response = await axios.post(
        "https://api.v1.spotyourleads.com/user/setModerator",
        {
          uid: userUid,
          adminUid: uid,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
            "x-admin-uid": uid,
          },
        }
      );
      Swal.fire({
        title: "Success",
        text: "User is now a moderator.",
        icon: "success",
      });
      fetchUsers();
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.response?.data?.message || "Error setting moderator",
        icon: "error",
      });
    }
  };

  const handleAddBalance = async () => {
    try {
      await axios.post(
        "https://api.v1.spotyourleads.com/user/addBalance",
        {
          amount: parseFloat(balance),
          uid: selectedUser,
          adminUid: uid,
        },
        {
          headers: {
            "x-api-key": apiKey,
            "Content-Type": "application/json",
          },
        }
      );
      Swal.fire("Success", "Balance added successfully", "success");
      fetchUsers();
      setShowModal(false);
      setBalance(0);
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message || "Error adding balance",
        "error"
      );
    }
  };

  const exportToCSV = () => {
    if (!users || users.length === 0) return;

    const headers = Object.keys(users[0]);
    const csvRows = [
      headers.join(","), // header row
      ...users.map((user) =>
        headers
          .map((field) => {
            let value = user[field];
            if (Array.isArray(value)) return `"${value.join(", ")}"`;
            if (typeof value === "string")
              return `"${value.replace(/"/g, '""')}"`;
            return value ?? "";
          })
          .join(",")
      ),
    ];

    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", "users.csv");
    a.click();
  };
  const fetchUserHistory = async (email) => {
    try {
      setHistoryLoading(true);
      const res = await axios.get(
        `https://api.v1.spotyourleads.com/user/purchaseHistory/${email}`,
        {
          headers: {
            "x-api-key": apiKey,
          },
        }
      );
      setUserHistory(res.data?.leads || []);
      setShowHistoryModal(true);
    } catch (error) {
      console.error("Error fetching user history:", error);
      Swal.fire("Error", "Failed to fetch user history", error);
    } finally {
      setHistoryLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Spot Your Leads | My Dashboard </title>
      </Helmet>
      <section className="leadsShop my-admin-dashboard">
        <Container fluid>
          <div>
            <Container fluid className="mx-auto p-6">
              <div className="overflow-x-auto my-5 table-container">
                <Button
                  variant="success"
                  onClick={exportToCSV}
                  className="my-2"
                >
                  Export to CSV
                </Button>
                <table className="history-table table table-bordered table-striped">
                  <thead>
                    <tr className="bg-gray-100 text-gray-600 uppercase text-sm leading-normal">
                      <th className="py-3 px-6 text-left">ID</th>

                      <th className="py-3 px-6 text-left">Name</th>
                      <th className="py-3 px-6 text-left">Email</th>
                      <th className="py-3 px-6 text-left">Experience</th>
                      <th className="py-3 px-6 text-left">Role</th>
                      <th className="py-3 px-6 text-left">Admin</th>
                      <th className="py-3 px-6 text-left">Moderator</th>
                      {localStorage.getItem("isAdmin") === "true" ? (
                        <th className="py-3 px-6 text-left">-</th>
                      ) : null}
                      <th className="py-3 px-6 text-left">Wallet</th>

                      <th className="py-3 px-6 text-left">Leads Purchased</th>
                      <th className="py-3 px-6 text-left">
                        Leads Purchased Free
                      </th>
                      <th className="py-3 px-6 text-left">Market</th>
                      <th className="py-3 px-6 text-left">Photo</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700 text-sm">
                    {users?.map((user) => (
                      <tr key={user.id} className="border-b hover:bg-gray-100">
                        <td className="py-3 px-6">{user.id}</td>

                        <td className="py-3 px-6">{user.name}</td>
                        <td className="py-3 px-6">{user.email}</td>
                        <td className="py-3 px-6">{user.experience}</td>

                        <td className="py-3 px-6">{user.role}</td>

                        <td className="py-3 px-6">
                          {user.isAdmin ? "Yes" : "No"}
                        </td>
                        <td className="py-3 px-6">
                          {user.isModerator ? "Yes" : "No"}
                        </td>
                        {localStorage.getItem("isAdmin") === "true" ? (
                          <td className="py-3 px-6">
                            <div className="d-flex gap-1">
                              <button
                                className="btn-table text-white font-bold py-1 px-2 rounded"
                                onClick={() => handleSetModerator(user.id)}
                              >
                                {user.isModerator
                                  ? "Set User"
                                  : "Set Moderator"}
                              </button>
                              <button
                                className="btn-table text-white font-bold py-1 px-2 rounded"
                                onClick={() => {
                                  setSelectedUser(user.id);
                                  setSelectedUserName(user.name);

                                  setShowModal(true);
                                }}
                              >
                                Add Balance
                              </button>
                              <button
                                className="btn-table text-white font-bold py-1 px-2 rounded"
                                onClick={() => fetchUserHistory(user.email)}
                              >
                                Show History
                              </button>
                            </div>
                          </td>
                        ) : null}
                        <td className="py-3 px-6">{user.wallet}</td>

                        <td className="py-3 px-6">{user.leadsPurchased}</td>
                        <td className="py-3 px-6">{user.leadsPurchasedFree}</td>

                        <td className="py-3 px-6">
                          {user.market && Array.isArray(user.market)
                            ? user.market.join(", ")
                            : "-"}
                        </td>
                        <td className="py-3 px-6">
                          {user.photoUrl && (
                            <img
                              src={user.photoUrl}
                              alt={user.name}
                              style={{ width: "50px", borderRadius: "50%" }}
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Container>
          </div>
        </Container>
      </section>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Balance to {selectedUserName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Balance Amount</Form.Label>
              <Form.Control
                type="number"
                value={balance}
                onChange={(e) => setBalance(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            className="btn-table text-white font-bold py-1 px-2 rounded"
            onClick={handleAddBalance}
          >
            Add Balance
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showHistoryModal}
        onHide={() => setShowHistoryModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>User History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {historyLoading ? (
            <p>Loading...</p>
          ) : userHistory.length === 0 ? (
            <p>No history found.</p>
          ) : (
            <Row>
              {userHistory.map((lead, index) => (
                <Col key={index} lg={12}>
                  <div
                    className="leads-items row"
                    style={{
                      height:
                        expandedIndex === index
                          ? "auto"
                          : window.innerWidth >= 768
                          ? "100px"
                          : "350px",
                      overflow: "hidden",
                      transition: "height 0.3s ease",
                      border: "1px solid #ddd",
                      margin: "15px 0",
                      padding: "15px",
                      borderRadius: "5px",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        marginTop: "10px",
                        textAlign: "center",
                      }}
                    >
                      <button
                        onClick={() => toggleDetails(index)}
                        style={{
                          padding: "5px",
                          cursor: "pointer",
                          width: "100px",
                          borderRadius: "4px",
                          border: "none",
                          backgroundColor: "#007bff",
                          color: "#fff",
                          position: "absolute",
                          bottom: "1px",
                          right: "1px",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          justifyContent: "center",
                          fontSize: "10px",
                        }}
                      >
                        {expandedIndex === index ? (
                          <>
                            Load Less <FaAngleUp style={{ fontSize: "12px" }} />
                          </>
                        ) : (
                          <>
                            Load More{" "}
                            <FaAngleDown style={{ fontSize: "12px" }} />
                          </>
                        )}
                      </button>
                    </div>

                    <div className="col-md-4">
                      <iframe
                        src={`https://maps.google.com/maps?q=${encodeURIComponent(
                          lead.propertyAddress
                        )}&z=10&output=embed`}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        style={{ width: "100%", height: "300px" }}
                        title={`Map-${index}`}
                      ></iframe>
                    </div>

                    <div className="col-md-4">
                      <p>
                        <strong>Date:</strong>{" "}
                        {new Date(lead.purchasedAt * 1000).toLocaleDateString()}
                        <br />
                      </p>
                      <p>
                        <strong>Time:</strong>{" "}
                        {new Date(lead.purchasedAt * 1000).toLocaleTimeString()}
                        <br />
                      </p>
                      <p>
                        <strong>Address:</strong> {lead.propertyAddress}
                        <br />
                      </p>
                      <p>
                        <strong>Property Type:</strong> {lead.propertyType}
                        <br />
                      </p>
                      <p>
                        <strong>Owner:</strong> {lead.propertyOwner}
                        <br />
                      </p>
                      <p>
                        <strong>Lead Notes:</strong>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: lead.leadTemplate,
                          }}
                        />
                      </p>
                      <p>
                        <strong>Reason for Selling:</strong>{" "}
                        {lead.sellingReason}
                        <br />
                      </p>
                      <p>
                        <strong>Mortgage:</strong> {lead.hasMortgage}
                        <br />
                      </p>
                    </div>

                    <div className="col-md-4">
                      <p>
                        <strong>Owned Years:</strong> {lead.ownedYears}
                        <br />
                      </p>
                      <p>
                        <strong>Occupancy:</strong> {lead.livingStatus}
                        <br />
                      </p>
                      <p>
                        <strong>Property Listed:</strong> {lead.propertyListed}
                        <br />
                      </p>
                      <p>
                        <strong>Phone:</strong> {lead.phoneNumber}
                        <br />
                      </p>
                      <p>
                        <strong>Price:</strong> ${lead.price}
                        <br />
                      </p>
                      <p>
                        <strong>Source:</strong> {lead.source}
                        <br />
                      </p>
                      <p>
                        <strong>Status:</strong> {lead.purchasedStatus}
                        <br />
                      </p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowHistoryModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </>
  );
}

export default Users;
